import { styled } from 'dripsy';
import React from 'react';
import { View } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';
import { Observer, observer } from 'mobx-react-lite';

import { LogoImage } from '../common/LogoImage';
import { IconTouchable } from '../common/IconTouchable';
import { IconWithBadge } from '../common/IconWithBadge';
import { Touchable } from '../common/Touchable';
import { Separator } from '../common/Separator';
import { BaseMobileHeader } from './BaseMobileHeader';
import { MainStackParamListType, screens } from '@navigation';
import { useAsyncInit } from '@hooks';
import { useChatsModel } from '@models/Chats/ChatsModel';

const Logo = styled(LogoImage)({
  width: 130,
  height: 38,
});

const ChatIconContainer = styled(View)({
  p: '$1',
  flexDirection: 'row',
});

type NavigationPropType =
  NativeStackNavigationProp<MainStackParamListType>;

export const MainHeader = observer(() => {
  const nav = useNavigation<NavigationPropType>();
  const chats = useChatsModel();

  useAsyncInit(async () => {
    try {
      await chats.fetchCount.run();
    } catch (error) {
      // Do nothing
    }
  });

  function navigateToChats() {
    nav.navigate(screens.ChatNavigator, {
      screen: screens.Chats,
    });
  }

  function navigateToContactUsForm() {
    nav.navigate(screens.ProfileNavigator, {
      screen: screens.ContactUs,
    });
  }

  return (
    <BaseMobileHeader
      LeftComponent={() => <Logo />}
      RightComponent={() => (
        <Observer>
          {() => (
            <ChatIconContainer>
              <IconTouchable
                onPress={navigateToContactUsForm}
                name="question-square"
              />
              <Separator vertical size="$8" />
              {chats.hasNewMessages ? (
                <Touchable borderless onPress={navigateToChats}>
                  <IconWithBadge
                    name="chat-light"
                    text={chats.formattedNewCount}
                    badgeColor="$primary300"
                  />
                </Touchable>
              ) : (
                <IconTouchable
                  onPress={navigateToChats}
                  name="chat-light"
                />
              )}
            </ChatIconContainer>
          )}
        </Observer>
      )}
    />
  );
});
